module.exports = __webpack_public_path__ + "app/assets/fonts/glyphicons-halflings-regular.svg?89889688147bd7575d6327160d64e760";


//////////////////
// WEBPACK FOOTER
// ./~/@suntransfers/st-ui/dist/styles/fonts/glyphicons-halflings-regular.svg
// module id = 179
// module chunks = 1